/**
 * @ngInject
 */

function intro() {

    return {
        addClass : function (elem, className, done) {
        },
        removeClass : function (elem, className, done) {
            if (className === 'ng-hide'){
                
                // Animation here
            }
        }
    }
}